import { AppShell, Burger, Button, Group, MantineProvider, ScrollArea, Text, ThemeIcon, UnstyledButton } from "@mantine/core";
import '@mantine/core/styles.css';
import { useDisclosure } from "@mantine/hooks";
import { IconDatabase, IconEye, IconHome, IconPower, IconSettings } from '@tabler/icons-react';
import { Link } from 'gatsby';
import React from "react";
import { useAppDispatch as useDispatch } from '../../hooks/ReduxHooks';
import { resetState } from "../../redux/authSlice";
import { theme } from "../api";

// const Layout: React.FC<{ children: React.ReactNode; language: string }> = ({ children, language }) => {
const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const dispatch = useDispatch()
	const bgArray = ['/herobg.jpg', '/bg2.webp']
	const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
    const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
	const navItems = [
		{ label: 'Dashboard', icon: IconHome, link: '/admin' },
		{ label: 'Website Content', icon: IconDatabase, link: '/admin/content' },
		{ label: 'Settings', icon: IconSettings, link: '/admin/settings' },
	];
	const handleLogin = () => {dispatch(resetState())}
    return (
		<>
		<MantineProvider theme={theme}>
			<AppShell
				header={{ height: 60 }}
				navbar={{ width: 250, breakpoint: 'sm', collapsed: { mobile: !mobileOpened, desktop: !desktopOpened }, }}
				padding="md"
			>
				<AppShell.Header bg={'grape'}>
					<Group h="100%" px="md">
						<Burger opened={mobileOpened} onClick={toggleMobile} hiddenFrom="sm" size="sm" />
						<Burger opened={desktopOpened} onClick={toggleDesktop} visibleFrom="sm" size="sm" />
						<Button component={Link} to="/" variant="link" radius={'lg'} color="white" leftSection={<IconPower size={18} />} onClick={handleLogin}> 
							<Text size="xl" fw={700} c={"white"}>Log out</Text>
						</Button>
						<Button component={Link} to="/" variant="link" radius={'lg'} color="white" leftSection={<IconEye size={18} />} ml={2}>
							<Text size="xl" fw={700} c={"white"}>Show Website</Text>
						</Button>
					</Group>
				</AppShell.Header>
				<AppShell.Navbar p="md" bg={'indigo'}>
					<ScrollArea>
						{navItems.map((item) => (
							<UnstyledButton component={Link} to={item.link} key={item.label} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
							<ThemeIcon size="lg" variant="light" color="cyan">
								<item.icon />
							</ThemeIcon>
							<Text ml="sm" c="white">
								{item.label}
							</Text>
							</UnstyledButton>
						))}
					</ScrollArea>
				</AppShell.Navbar>
				<AppShell.Main bg={'#F0F0FF'}>
					{children}
					{/* <Outlet /> */}
				</AppShell.Main>
			</AppShell>
		</MantineProvider>
		</>
    )
}

export default AdminLayout